var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "26px",
    viewBox: "0 0 31 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6587\u4EF6\u5939") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.00180139985 0.00225907384 29.4451415 0.00225907384 29.4451415 24.2543387 0.00180139985 24.2543387"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u6587\\u4EF6\\u5939",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0790629,3.61428035 C28.3858884,3.61428035 29.4451415,4.65312735 29.4451415,5.9355679 L29.4451415,21.9329021 C29.4451415,23.2153426 28.3858884,24.2543387 27.0790629,24.2543387 L2.36598859,24.2543387 C1.05925313,24.2551408 0,23.2161749 0,21.9337046 L0,2.32286295 C0,1.04122497 1.05925313,0.00225907384 2.36598859,0.00225907384 L8.41310774,0.00225907384 C10.4110703,0.00225907384 10.6208734,0.621602003 11.9359253,2.32369524 C13.0402134,3.71724656 15.7210867,3.61428035 17.4042547,3.61428035 L27.0790629,3.61428035 Z",
    id: "Fill-1",
    fill: "#3D89F4",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.0819655,25.2553191 C29.3914661,25.2553191 30.4528875,24.2026794 30.4528875,22.9054381 L30.4528875,8.54777395 C30.4528875,7.24974794 29.3914661,6.19821617 28.0819655,6.19821617 L5.84777255,6.19821617 C5.21129877,6.18336676 4.59525256,6.42433776 4.13657987,6.86740567 C3.68142711,7.30727433 3.4239314,7.91383672 3.42348013,8.54777395 L3.42348013,22.9054381 C3.43334794,23.0274629 3.43334794,23.1493669 3.42348013,23.2713917 C3.42348013,23.9340016 2.88135224,24.4713573 2.21172502,24.4713573 C1.54694145,24.4754922 1.00457289,23.9383478 1,23.2713917 C1.18321636,24.4244548 2.19292203,25.2691813 3.37095209,25.2553191 L28.0819655,25.2553191 Z",
    id: "Fill-3",
    fill: "#FFFFFF",
    opacity: 0.203985305
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.354dd116d83762161c5e01563781ff2a.svg";
export { ForwardRef as ReactComponent };